import { render, staticRenderFns } from "./EditIABFPiece.vue?vue&type=template&id=1cd0193b"
import script from "./EditIABFPiece.vue?vue&type=script&lang=js"
export * from "./EditIABFPiece.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports